import React, { Component } from 'react';
import Workspacemodal from './workspacemodal.jsx';
import { toast } from 'react-toastify';

//for connecting
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actionCreators from '../actions/workspace';

class Workspacepage extends Component {

    constructor(props) {
        super(props);
        this.handleActiveChange = this.handleActiveChange.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.delete = this.delete.bind(this)
        this.state = {fetched: false}
    }

    init(props, state){
        if( !this.state.fetched ){
            this.setState({fetched: true})   
            this.props.getWorkspaceList();
        }
    }

    componentWillMount(){
        this.init(this.props, this.state)
    }
  
    handleActiveChange(id, status){
        this.props.changeActivationStatus(id, status)
    }


    toggleModal(index){
        let newIndex = null;
        if(index){
            newIndex = index;
        }
        this.setState({openModal: !this.state.openModal, index: newIndex})
    }

    delete = ( ws={} )=>{
        if(!this.deleteNotifOpened){
          toast.info((
            <div className="delete-notif">
              <p>
              آیا برای حذف محیط کار
              { ' "'+ ws.name.trunc(18) +'" '}
              مطمئن هستید؟
              </p>
              <button className='btn btn-sm btn-success' onClick={this.props.deleteWorkspace.bind(null, ws.id)}>بله</button>
              <button className='btn btn-sm btn-danger'>خیر</button>
            </div>
            ), {
            onOpen: () => this.deleteNotifOpened = true,
            onClose: () => this.deleteNotifOpened = false,
            closeButton: false,
            rtl : true
          });
        }
        
    }

    render() {
        const appData = JSON.parse(localStorage.getItem('appData')) || {};
        let userPhone = '';
        if(appData.user) userPhone = (appData.user.phone_number).trim();
        let workspaces = this.props.app.work_space_list;
        

        const mappedWorkspaces = workspaces.map((workspace,index) => (
            <tr key={index}>
                <td onClick={()=>{this.toggleModal(workspace)}}>{index+1}</td>
                <td onClick={()=>{this.toggleModal(workspace)}}> {workspace.name.trunc(35)} </td>
                <td onClick={()=>{this.toggleModal(workspace)}}> {workspace.owner.name.trunc(35)} </td>
                <td>
                    {(userPhone === workspace.owner.phone_number)?(
                            <i onClick={()=>{this.delete(workspace)}} className="glyphicon glyphicon-trash"></i>
                    ):(null)}
                </td>
            </tr>
        ));
        return (
            <div className="container">
                <div className="row title" >
                    <div className="col-md-5 col-md-push-1">
                        <h2>مدیریت محیط‌های کار</h2>
                    </div>
                    <div className="col-md-2 pull-left col-md-pull-1" >
                        <button className="btn btn-success btn-block btn-lg pull-left " style={{marginTop:'15px'}} onClick={()=>{this.toggleModal()}}>محیط کار جدید</button>
                    </div>
                </div>            

                <div className="row">
                    <table className="table col-md-10 col-md-push-1 project-table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>نام محیط کار</th>
                                <th>مدیر محیط کار</th>
                                <th>حذف</th>
                            </tr>
                        </thead>
                        <tbody>
                            {mappedWorkspaces}
                        </tbody>
                    </table>
                </div>
                {(this.state.openModal)?(<Workspacemodal userPhone={userPhone} index={this.state.index} toggleModal={this.toggleModal} />):(null)}

            </div>
        );
    }
    }

function mapStateToProps(state) {
  return {
    app: state.app
  }
}

function mapDispachToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}
  
export default connect(mapStateToProps, mapDispachToProps)(Workspacepage);